import { Box, Stack, Avatar, Typography, Divider, IconButton, Dialog, TextField, Button } from '@mui/material';
import { Schema } from '../../../../../amplify/data/resource';
import { Icon } from '@iconify/react';
import CoinsIcon from '../../../icons/CoinsIcon';
import { signOut } from 'aws-amplify/auth';
import { useNavigate } from 'react-router-dom';
import { useState, useRef, useEffect } from 'react';
import { generateClient } from 'aws-amplify/api';
import Select from '../../../custom/Select';

// @ts-ignore
type Agent = Schema['User']['type'];

const apiClient = generateClient<Schema>();

interface BankOption {
  label: string;
  value: string;
}

interface BranchOption {
  label: string;
  value: string;
  number: number;
}

const Main = ({ agent }: { agent: Agent }) => {
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [userData, setUserData] = useState({
    businessName: (agent as any)?.businessName || '',
    fullName: agent?.fullName || '',
    userId: agent?.userId || '',
    email: agent?.email || '',
    phone: agent?.phone || '',
    agentId: agent?.agentId || '',
    agencyId: agent?.agencyId || '',
    bankNumber: (agent as any)?.bankNumber || '',
    branchNumber: (agent as any)?.branchNumber || '',
    accountNumber: (agent as any)?.accountNumber || '',
  });

  const handleEditClick = () => {
    setEditDialogOpen(true);
  };

  const handleSave = () => {
    // Здесь будет логика сохранения данных
    setEditDialogOpen(false);
  };

  const handleInputChange = (field: string, value: string) => {
    setUserData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  return (
    <Stack 
      sx={{ 
        width: '100%', 
        height: '100%',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'relative'
      }}
    >


      <Stack spacing={5} sx={{ width: '100%', alignItems: 'center', flex: 1 }}>
        <UserAvatar fullName={userData.fullName} userData={userData} />
        <Stack sx={{ width: '100%' }} spacing={2}>
          {/* ח.פ */}
          <Typography
            fontWeight={'400'}
            fontSize={'16px'}
            fontFamily={'AlmoniDL'}
            color={'#808080'}
            textAlign="center"
            sx={{ mb: 2 }}
          >
            {userData.agentId || 'לא צוין'}
          </Typography>

          {/* פרטי מורשה חתימה */}
          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
            <Stack 
              direction="row" 
              alignItems="center" 
              spacing={0.5}
              onClick={handleEditClick}
              sx={{ 
                cursor: 'pointer',
                '&:hover': {
                  '& .edit-text': {
                    color: '#424245',
                  },
                },
              }}
            >
              <Icon icon="material-symbols:edit" width="16px" color="#666" />
              <Typography
                className="edit-text"
                fontWeight={'400'}
                fontSize={'14px'}
                fontFamily={'AlmoniDL'}
                color={'#666'}
              >
                ערוך פרטים
              </Typography>
            </Stack>
            <Typography
              fontWeight={'700'}
              fontSize={'18px'}
              fontFamily={'AlmoniDL'}
              color={'#424245'}
              textAlign="right"
            >
              פרטי מורשה חתימה
            </Typography>
          </Stack>

          {/* שורה ראשונה - שם מלא ות.ז */}
          <Stack direction="row" justifyContent="space-between" sx={{ mb: 1 }}>
            <Stack sx={{ flex: 1, alignItems: 'flex-start' }}>
              <Typography
                fontWeight={'400'}
                fontSize={'14px'}
                fontFamily={'AlmoniDL'}
                color={'#808080'}
              >
                ת.ז
              </Typography>
              <Typography
                fontWeight={'700'}
                fontSize={'16px'}
                fontFamily={'AlmoniDL'}
                color={'#424245'}
              >
                {userData.userId || 'לא צוין'}
              </Typography>
            </Stack>
            <Stack sx={{ flex: 1, alignItems: 'flex-end' }}>
              <Typography
                fontWeight={'400'}
                fontSize={'14px'}
                fontFamily={'AlmoniDL'}
                color={'#808080'}
                textAlign="right"
              >
                שם מלא
              </Typography>
              <Typography
                fontWeight={'700'}
                fontSize={'16px'}
                fontFamily={'AlmoniDL'}
                color={'#424245'}
                textAlign="right"
              >
                {userData.fullName || 'לא צוין'}
              </Typography>
            </Stack>
          </Stack>

          {/* שורה שנייה - מייל וטלפון */}
          <Stack direction="row" justifyContent="space-between" sx={{ mb: 1 }}>
            <Stack sx={{ flex: 1, alignItems: 'flex-start' }}>
              <Typography
                fontWeight={'400'}
                fontSize={'14px'}
                fontFamily={'AlmoniDL'}
                color={'#808080'}
              >
                טלפון
              </Typography>
              <Typography
                fontWeight={'700'}
                fontSize={'16px'}
                fontFamily={'AlmoniDL'}
                color={'#424245'}
              >
                {userData.phone || 'לא צוין'}
              </Typography>
            </Stack>
            <Stack sx={{ flex: 1, alignItems: 'flex-end' }}>
              <Typography
                fontWeight={'400'}
                fontSize={'14px'}
                fontFamily={'AlmoniDL'}
                color={'#808080'}
                textAlign="right"
              >
                כתובת מייל
              </Typography>
              <Typography
                fontWeight={'700'}
                fontSize={'16px'}
                fontFamily={'AlmoniDL'}
                color={'#424245'}
                textAlign="right"
                noWrap
                sx={{ maxWidth: '150px', textOverflow: 'ellipsis' }}
              >
                {userData.email || 'לא צוין'}
              </Typography>
            </Stack>
          </Stack>

          {/* מספר בנק */}
          <Stack sx={{ alignItems: 'center', mt: 2 }}>
            <Typography
              fontWeight={'400'}
              fontSize={'14px'}
              fontFamily={'AlmoniDL'}
              color={'#808080'}
              textAlign="center"
            >
              מספר חשבון
            </Typography>
            <Typography
              fontWeight={'700'}
              fontSize={'16px'}
              fontFamily={'AlmoniDL'}
              color={'#424245'}
              textAlign="center"
            >
              {userData.bankNumber && userData.branchNumber && userData.accountNumber
                ? `${userData.bankNumber}.${userData.branchNumber}.${userData.accountNumber}`
                : 'לא צוין'}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
      <Buttons />

      {/* Диалог редактирования */}
      <EditDialog
        open={editDialogOpen}
        onClose={() => setEditDialogOpen(false)}
        userData={userData}
        onInputChange={handleInputChange}
        onSave={handleSave}
      />
    </Stack>
  );
};

export default Main;

const UserAvatar = ({ fullName, userData }: { fullName: string; userData: any }) => {
  // Состояние для хранения URL аватарки
  const [avatarUrl, setAvatarUrl] = useState<string | null>(null);
  // Ref для доступа к скрытому input[type="file"]
  const fileInputRef = useRef<HTMLInputElement>(null);

  // Обработчик изменения файла
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if (file) {
      // Создаем URL объекта для предпросмотра изображения
      const reader = new FileReader();
      reader.onloadend = () => {
        setAvatarUrl(reader.result as string);
      };
      reader.readAsDataURL(file);
      // В реальном приложении здесь вы бы также отправили файл на сервер
    }
  };

  // Обработчик клика по кнопке-иконке
  const handleButtonClick = () => {
    // Триггерим клик по скрытому input
    fileInputRef.current?.click();
  };

  return (
    <Stack spacing={2} sx={{ alignItems: 'center' }}>
      {/* Контейнер для аватарки и кнопки */}
      <Box sx={{ position: 'relative', width: '120px', height: '120px' }}>
        {/* Аватарка */}
        <Avatar
          src={avatarUrl || undefined}
          sx={{
            borderRadius: '40px',
            width: '120px',
            height: '120px',
            bgcolor: avatarUrl ? 'transparent' : '#DBE4EC',
            color: '#343434',
            fontWeight: '900',
            fontSize: '32px',
            fontFamily: 'Montserrat',
            position: 'absolute',
            top: 0,
            left: 0,
          }}
        >
          {!avatarUrl && 'P'}
        </Avatar>

        {/* Скрытый input для выбора файла */}
        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          onChange={handleFileChange}
          style={{ display: 'none' }}
        />

        {/* Кнопка-иконка поверх аватарки */}
        <IconButton
          aria-label="upload picture"
          component="span"
          onClick={handleButtonClick}
          sx={{
            position: 'absolute',
            bottom: 0,
            right: 0,
            transform: 'translate(10%, 10%)',
            bgcolor: '#C1FE40',
            color: '#343434',
            width: '32px',
            height: '32px',
            '&:hover': {
              bgcolor: '#B6F829',
            },
          }}
        >
          <Icon icon="material-symbols:photo-camera" fontSize="small" />
        </IconButton>
      </Box>
      <Typography
        fontWeight={'700'}
        fontSize={'24px'}
        fontFamily={'AlmoniDL'}
        color={'#424245'}
        textAlign="center"
      >
        {userData.businessName || 'שם העסק'}
      </Typography>
    </Stack>
  );
};

const InfoItem = ({ label, value }: { label: string; value: string }) => {
  return (
    <Stack sx={{ width: '100%' }}>
      <Typography
        textAlign="right"
        fontWeight={'400'}
        fontSize={'16px'}
        fontFamily={'AlmoniDL'}
        color={'#808080'}
      >
        {label}
      </Typography>
      <Typography
        textAlign="right"
        fontWeight={'700'}
        fontSize={'18px'}
        fontFamily={'AlmoniDL'}
        color={'#424245'}
        noWrap
        sx={{
          textOverflow: 'ellipsis',
        }}
      >
        {value}
      </Typography>
    </Stack>
  );
};

const BankInfoItem = ({ 
  bankNumber, 
  branchNumber, 
  accountNumber 
}: { 
  bankNumber: string; 
  branchNumber: string; 
  accountNumber: string; 
}) => {
  const bankInfo = `${bankNumber} . ${branchNumber} . ${accountNumber}`;
  
  return (
    <Stack sx={{ width: '100%' }}>
      <Typography
        textAlign="right"
        fontWeight={'400'}
        fontSize={'16px'}
        fontFamily={'AlmoniDL'}
        color={'#808080'}
      >
        מספר בנק
      </Typography>
      <Typography
        textAlign="right"
        fontWeight={'700'}
        fontSize={'18px'}
        fontFamily={'AlmoniDL'}
        color={'#424245'}
        noWrap
        sx={{
          textOverflow: 'ellipsis',
        }}
      >
        {bankInfo || 'לא צוין'}
      </Typography>
    </Stack>
  );
};

const EditDialog = ({ 
  open, 
  onClose, 
  userData, 
  onInputChange, 
  onSave 
}: {
  open: boolean;
  onClose: () => void;
  userData: any;
  onInputChange: (field: string, value: string) => void;
  onSave: () => void;
}) => {
  const [banks, setBanks] = useState<BankOption[]>([]);
  const [branches, setBranches] = useState<BranchOption[]>([]);

  // Fetch banks when dialog opens
  useEffect(() => {
    const fetchBanks = async () => {
      if (!open) return;
      
      try {
        const response = await apiClient.queries.getBanksInfo({});
        let banksList: BankOption[] = [];
        if (response?.data) {
          try {
            const data =
              typeof response.data === 'string'
                ? JSON.parse(response.data)
                : response.data;
            if (data && data.body && Array.isArray(data.body)) {
              banksList = data.body
                .map((bank: any) => ({
                  label: bank.name || '',
                  value: bank.number ? String(bank.number) : '',
                }))
                .filter((bank: BankOption) => bank.label && bank.value);
            }
          } catch (e) {
            console.error('Error processing bank data:', e);
          }
        }
        setBanks(banksList);
      } catch (error) {
        console.error('Error fetching banks:', error);
        setBanks([]);
      }
    };
    
    fetchBanks();
  }, [open]);

  // Fetch branches when bank changes
  useEffect(() => {
    const fetchBranches = async () => {
      if (!userData.bankNumber || !open) {
        setBranches([]);
        return;
      }
      
      try {
        const response = await apiClient.queries.getBanksInfo({
          bank: userData.bankNumber,
        });
        let branchesList: BranchOption[] = [];
        if (response?.data) {
          try {
            const data =
              typeof response.data === 'string'
                ? JSON.parse(response.data)
                : response.data;
            if (data && data.body && Array.isArray(data.body)) {
              branchesList = data.body
                .map((branch: any) => ({
                  label: branch.name
                    ? `${branch.branch || ''} - ${branch.name}`
                    : branch.branch || '',
                  value: branch.branch || '',
                  number: parseInt(branch.branch || '0', 10)
                }))
                .filter((branch: BranchOption) => branch.value)
                .sort((a: BranchOption, b: BranchOption) => a.number - b.number);
            }
          } catch (e) {
            console.error('Error processing branch data:', e);
          }
        }
        setBranches(branchesList);
      } catch (error) {
        console.error('Error fetching branches:', error);
        setBranches([]);
      }
    };
    
    fetchBranches();
  }, [userData.bankNumber, open]);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '20px',
          p: 0,
          maxWidth: '900px',
        },
      }}
    >
      <Stack sx={{ position: 'relative' }}>
        {/* Заголовок с кнопкой закрытия */}
        <Stack 
          direction="row" 
          justifyContent="space-between" 
          alignItems="center"
          sx={{ 
            p: 3,
            pb: 2,
          }}
        >
          <Typography
            fontWeight={'700'}
            fontSize={'24px'}
            fontFamily={'AlmoniDL'}
            textAlign="right"
          >
            עריכת פרטי פרופיל
          </Typography>
          <IconButton 
            onClick={onClose}
            sx={{ 
              position: 'absolute',
              top: 16,
              left: 16,
            }}
          >
            <Icon icon="material-symbols:close" width="24px" />
          </IconButton>
        </Stack>

        {/* Основной контент в две колонки */}
        <Stack direction="row" spacing={4} sx={{ px: 3, pb: 3 }}>
          {/* Левая колонка - פרטי מורשה חתימה */}
          <Stack flex={1} spacing={3}>
            <Typography
              fontWeight={'700'}
              fontSize={'18px'}
              fontFamily={'AlmoniDL'}
              textAlign="right"
              color={'#374151'}
            >
              פרטי מורשה חתימה
            </Typography>

            {/* שם מלא */}
            <Stack>
              <Typography
                fontWeight={'400'}
                fontSize={'14px'}
                fontFamily={'AlmoniDL'}
                color={'#666'}
                textAlign="right"
                sx={{ mb: 1 }}
              >
                שם מלא
              </Typography>
              <TextField
                value={userData.fullName}
                onChange={(e) => onInputChange('fullName', e.target.value)}
                fullWidth
                variant="outlined"
                placeholder="שם מלא"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                    backgroundColor: '#F8F9FA',
                    '& fieldset': {
                      borderColor: '#E5E7EB',
                    },
                  },
                }}
              />
            </Stack>

            {/* ת.ז */}
            <Stack>
              <Typography
                fontWeight={'400'}
                fontSize={'14px'}
                fontFamily={'AlmoniDL'}
                color={'#666'}
                textAlign="right"
                sx={{ mb: 1 }}
              >
                ת.ז
              </Typography>
              <TextField
                value={userData.userId}
                onChange={(e) => onInputChange('userId', e.target.value)}
                fullWidth
                variant="outlined"
                placeholder="מספר תעודת זהות"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                    backgroundColor: '#F8F9FA',
                    '& fieldset': {
                      borderColor: '#E5E7EB',
                    },
                  },
                }}
              />
            </Stack>

            {/* כתובת מייל */}
            <Stack>
              <Typography
                fontWeight={'400'}
                fontSize={'14px'}
                fontFamily={'AlmoniDL'}
                color={'#666'}
                textAlign="right"
                sx={{ mb: 1 }}
              >
                כתובת מייל
              </Typography>
              <TextField
                value={userData.email}
                onChange={(e) => onInputChange('email', e.target.value)}
                fullWidth
                variant="outlined"
                type="email"
                placeholder="example@email.com"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                    backgroundColor: '#F8F9FA',
                    '& fieldset': {
                      borderColor: '#E5E7EB',
                    },
                  },
                }}
              />
            </Stack>

            {/* טלפון */}
            <Stack>
              <Typography
                fontWeight={'400'}
                fontSize={'14px'}
                fontFamily={'AlmoniDL'}
                color={'#666'}
                textAlign="right"
                sx={{ mb: 1 }}
              >
                טלפון
              </Typography>
              <TextField
                value={userData.phone}
                onChange={(e) => onInputChange('phone', e.target.value)}
                fullWidth
                variant="outlined"
                placeholder="מספר טלפון"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                    backgroundColor: '#F8F9FA',
                    '& fieldset': {
                      borderColor: '#E5E7EB',
                    },
                  },
                }}
              />
            </Stack>

            {/* Кнопка сохранения */}
            <Button
              onClick={onSave}
              variant="contained"
              fullWidth
              sx={{
                bgcolor: '#10B981',
                color: 'white',
                fontWeight: '700',
                fontSize: '16px',
                fontFamily: 'AlmoniDL',
                borderRadius: '12px',
                py: 2,
                mt: 3,
                textTransform: 'none',
                boxShadow: 'none',
                '&:hover': {
                  bgcolor: '#059669',
                  boxShadow: 'none',
                },
              }}
            >
              שמירה
            </Button>
          </Stack>

          {/* Разделитель */}
          <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />

          {/* Правая колонка - פרטי עסק וחשבון */}
          <Stack flex={1} spacing={3}>
            {/* שם העסק */}
            <Stack>
              <Typography
                fontWeight={'400'}
                fontSize={'14px'}
                fontFamily={'AlmoniDL'}
                color={'#666'}
                textAlign="right"
                sx={{ mb: 1 }}
              >
                שם העסק
              </Typography>
              <TextField
                value={userData.businessName}
                onChange={(e) => onInputChange('businessName', e.target.value)}
                fullWidth
                variant="outlined"
                placeholder="שם העסק"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                    backgroundColor: '#F8F9FA',
                    '& fieldset': {
                      borderColor: '#E5E7EB',
                    },
                  },
                }}
              />
            </Stack>

            {/* ח.פ */}
            <Stack>
              <Typography
                fontWeight={'400'}
                fontSize={'14px'}
                fontFamily={'AlmoniDL'}
                color={'#666'}
                textAlign="right"
                sx={{ mb: 1 }}
              >
                ח.פ
              </Typography>
              <TextField
                value={userData.agentId}
                onChange={(e) => onInputChange('agentId', e.target.value)}
                fullWidth
                variant="outlined"
                placeholder="מספר חברה"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                    backgroundColor: '#F8F9FA',
                    '& fieldset': {
                      borderColor: '#E5E7EB',
                    },
                  },
                }}
              />
            </Stack>

            {/* פרטי חשבון */}
            <Typography
              fontWeight={'700'}
              fontSize={'16px'}
              fontFamily={'AlmoniDL'}
              textAlign="right"
              color={'#374151'}
              sx={{ mt: 2 }}
            >
              פרטי חשבון
            </Typography>

            {/* בנק */}
            <Stack>
              <Typography
                fontWeight={'400'}
                fontSize={'14px'}
                fontFamily={'AlmoniDL'}
                color={'#666'}
                textAlign="right"
                sx={{ mb: 1 }}
              >
                בנק
              </Typography>
              <Select
                label=""
                value={userData.bankNumber}
                onChange={(value) => onInputChange('bankNumber', value)}
                options={banks}
                id="bank-select"
                disabled={!banks.length}
                sx={{
                  '& .MuiFilledInput-root': {
                    borderRadius: '8px',
                    backgroundColor: '#F8F9FA',
                    border: '1px solid #E5E7EB',
                  },
                }}
              />
            </Stack>

            {/* סניף */}
            <Stack>
              <Typography
                fontWeight={'400'}
                fontSize={'14px'}
                fontFamily={'AlmoniDL'}
                color={'#666'}
                textAlign="right"
                sx={{ mb: 1 }}
              >
                סניף
              </Typography>
              <Select
                label=""
                value={userData.branchNumber}
                onChange={(value) => onInputChange('branchNumber', value)}
                options={branches}
                id="branch-select"
                disabled={!userData.bankNumber || !branches.length}
                sx={{
                  '& .MuiFilledInput-root': {
                    borderRadius: '8px',
                    backgroundColor: '#F8F9FA',
                    border: '1px solid #E5E7EB',
                  },
                }}
              />
            </Stack>
            
            {/* מספר חשבון */}
            <Stack>
              <Typography
                fontWeight={'400'}
                fontSize={'14px'}
                fontFamily={'AlmoniDL'}
                color={'#666'}
                textAlign="right"
                sx={{ mb: 1 }}
              >
                מספר חשבון
              </Typography>
              <TextField
                value={userData.accountNumber}
                onChange={(e) => onInputChange('accountNumber', e.target.value)}
                fullWidth
                variant="outlined"
                placeholder="מספר חשבון בנק"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                    backgroundColor: '#F8F9FA',
                    '& fieldset': {
                      borderColor: '#E5E7EB',
                    },
                  },
                }}
              />
            </Stack>
          </Stack>
        </Stack>

      </Stack>
    </Dialog>
  );
};

const Buttons = () => {
  const navigate = useNavigate();

  const handleSignOut = () => {
    signOut();
    navigate('/login');
  };

  const handleWhatsAppClick = () => {
    window.open('https://wa.link/uuw7es', '_blank');
  };

  const handleTermsClick = () => {
    window.open('https://www.pielapay.co.il/terms', '_blank');
  };

  const handlePrivacyClick = () => {
    window.open('https://www.pielapay.co.il/privacy', '_blank');
  };

  const handleInvoicesClick = () => {
    // Логика для открытия счетов
  };

  return (
    <Stack 
      spacing={1}
      sx={{ 
        width: '100%', 
        position: 'absolute',
        bottom: -10,
        left: 0,
        right: 0,
        px: 2,
        bgcolor: 'white',
        borderRadius: '12px 12px 0 0',
        py: 2,
      }}
    >
      {/* Верхняя широкая кнопка - החשבוניות שלי */}
      <Stack
        sx={{
          alignItems: 'center',
          cursor: 'pointer',
          width: '100%',
          py: 2,
        }}
        onClick={handleInvoicesClick}
      >
        <Icon width="24px" icon="material-symbols:receipt-long" color="#424245" />
        <Typography
          fontWeight={'400'}
          fontSize={'12px'}
          fontFamily={'AlmoniDL'}
          color={'#424245'}
          textAlign="center"
          sx={{ mt: 0.5 }}
        >
          החשבוניות שלי
        </Typography>
      </Stack>

      {/* Вторая широкая кнопка - עזרה ותמיכה */}
      <Stack
        sx={{
          alignItems: 'center',
          cursor: 'pointer',
          width: '100%',
          py: 2,
        }}
        onClick={handleWhatsAppClick}
      >
        <Icon width="24px" icon="la:whatsapp" color="#25D366" />
        <Typography
          fontWeight={'400'}
          fontSize={'12px'}
          fontFamily={'AlmoniDL'}
          color={'#666'}
          textAlign="center"
          sx={{ mt: 0.5 }}
        >
          עזרה ותמיכה
        </Typography>
      </Stack>

      {/* Нижний ряд из трех кнопок */}
      <Stack 
        direction="row" 
        spacing={0} 
        sx={{ 
          width: '100%', 
          justifyContent: 'space-between',
        }}
      >
        <Stack
          sx={{
            alignItems: 'center',
            cursor: 'pointer',
            flex: 1,
            py: 1,
          }}
          onClick={handlePrivacyClick}
        >
          <Icon width="20px" icon="material-symbols:privacy-tip" color="#666" />
          <Typography
            fontWeight={'400'}
            fontSize={'10px'}
            fontFamily={'AlmoniDL'}
            color={'#666'}
            textAlign="center"
            sx={{ mt: 0.5 }}
          >
            מדיניות פרטיות
          </Typography>
        </Stack>

        <Stack
          sx={{
            alignItems: 'center',
            cursor: 'pointer',
            flex: 1,
            py: 1,
          }}
          onClick={handleTermsClick}
        >
          <Icon width="20px" icon="material-symbols:description" color="#666" />
          <Typography
            fontWeight={'400'}
            fontSize={'10px'}
            fontFamily={'AlmoniDL'}
            color={'#666'}
            textAlign="center"
            sx={{ mt: 0.5 }}
          >
            תנאי שימוש
          </Typography>
        </Stack>

        <Stack
          sx={{
            alignItems: 'center',
            cursor: 'pointer',
            flex: 1,
            py: 1,
          }}
          onClick={handleSignOut}
        >
          <Icon width="20px" icon="si:sign-out-alt-fill" color="#666" />
          <Typography
            fontWeight={'400'}
            fontSize={'10px'}
            fontFamily={'AlmoniDL'}
            color={'#666'}
            textAlign="center"
            sx={{ mt: 0.5 }}
          >
            יציאה
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
